import React, { useMemo } from 'react';
import RoleDashboardTemplate from './RoleDashboardTemplate';
import { useAuth } from '../../context/AuthContext';
import { buildRoleWorkspaceModules } from '../../config/roleWorkspaceConfig';

const ViewerDashboardPage = () => {
  const auth = useAuth();
  const modules = useMemo(() => buildRoleWorkspaceModules('viewer', auth), [auth]);

  return (
    <RoleDashboardTemplate
      title="Viewer Dashboard"
      subtitle="Read-only analytics workspace with restricted organization visibility."
      modules={modules}
    />
  );
};

export default ViewerDashboardPage;
